interface RendererContext {
  readonly RENDERER: number;
  getExtension(name: 'WEBGL_debug_renderer_info'): WEBGL_debug_renderer_info | null;
  getParameter(parameter: number): unknown;
}

/** Positive software evidence only. Privacy-masked/unknown renderer strings
 * retain normal auto mode and its measured frame-rate governor. No vendor
 * identity is stored or sent; this avoids compiling expensive reflected
 * materials before a known CPU rasterizer can select performance quality.
 */
export function usesSoftwareRasterizer(context: RendererContext): boolean {
  try {
    const extension = context.getExtension('WEBGL_debug_renderer_info');
    const renderer: unknown = context.getParameter(extension?.UNMASKED_RENDERER_WEBGL ?? context.RENDERER);
    return typeof renderer === 'string' && /swiftshader|llvmpipe|softpipe|software rasterizer/i.test(renderer);
  } catch {
    return false;
  }
}
